import { useState, useEffect } from "react";
import { getUserById } from "shared/api/client/orvalHelpers";
import { getCookie, clearUserSessionCookies } from "shared/auth/utils/cookieUtils";

export interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  socialProvider: string;
}

export function useCurrentUser(): User | null {
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    async function fetchUser() {
      try {
        const userId = getCookie("userId");
        if (!userId) {
          setUser(null);
          return;
        }

        const userData = await getUserById(userId);

        const userWithFallback = {
          ...userData,
          firstName: userData.firstName || getCookie("userFirstName") || "",
          lastName: userData.lastName || getCookie("userLastName") || "",
          email: userData.email || getCookie("userEmail") || "",
        };

        setUser(userWithFallback);
      } catch (err) {
        const status = (err as { response?: { status?: number } })?.response?.status;
        if (status === 401 || status === 403) {
          clearUserSessionCookies();
          setUser(null);
          return;
        }
        const userId = getCookie("userId");
        const userEmail = getCookie("userEmail");
        const firstName = getCookie("userFirstName");
        const lastName = getCookie("userLastName");
        if (userId && userEmail) {
          setUser({
            id: userId,
            firstName: firstName || "",
            lastName: lastName || "",
            email: userEmail,
            socialProvider: "",
          });
        } else {
          setUser(null);
        }
      }
    }
    fetchUser();
  }, []);

  return user;
}
